import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import SelectInput from "../../../../components/inputs/select";
import MaskInput from "../../../../components/inputs/mask";
import Loading from "../../../../components/loading";
import AlertMessage from "../../../../components/alert-message";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		control,
		errors,
		isSubmitting,
		handleSubmit,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//variables
		isInsert,
		loading,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		insert,
	});

	const diasSemana = [
		{ dia_semana: 1, descricao: "Domingo" },
		{ dia_semana: 2, descricao: "Segunda-feira" },
		{ dia_semana: 3, descricao: "Terça-feira" },
		{ dia_semana: 4, descricao: "Quarta-feira" },
		{ dia_semana: 5, descricao: "Quinta-feira" },
		{ dia_semana: 6, descricao: "Sexta-feira" },
		{ dia_semana: 7, descricao: "Sábado" },
	];

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(handleOnSubmit)}
				>
					<main className="overflow-auto">
						<div className="row">
							<SelectInput
								label="Dia da Semana"
								id="dia_semana"
								labelSelect="descricao"
								data={diasSemana}
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-4"
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
							/>

							<MaskInput
								label="Hora de Abertura"
								name="hora_abertura"
								format="##:##"
								placeholder="00:00"
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-4"
								onKeyDown={libForm.EnterTab}
							/>

							<MaskInput
								label="Hora de Fechamento"
								name="hora_fechamento"
								format="##:##"
								placeholder="00:00"
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-4"
								onKeyDown={libForm.EnterTab}
							/>

							<SelectInput
								label="Tipo / Modalidade"
								id="tipo"
								labelSelect="descricao"
								data={[
									{ tipo: "LOJA", descricao: "Loja" },
									{ tipo: "DELIVERY", descricao: "Delivery" },
									{ tipo: "AMBOS", descricao: "Ambos" },
								]}
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-4"
								onKeyDown={libForm.EnterTab}
							/>
							<div className="col-12">
								<p className="text-muted mt-1 mb-2" style={{ fontSize: "0.85rem" }}>
									* <strong>Modalidade:</strong> Permite que você aceite pedidos para retirada (Loja) mesmo quando o Delivery estiver fechado, ou vice-versa.
								</p>
							</div>

							<div className={`check-box col-12 col-sm-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_horario"
										type="checkbox"
										{...register("ativo")}
										autoComplete="off"
									/>
									<label htmlFor="ativo_horario">
										<span className="text-lg">Horário ativo</span>
									</label>
								</div>
							</div>
						</div>

						<AlertMessage type="info" title="Dica de Turno Cruzado">
							Você pode inserir perfeitamente horários de fechamento no dia seguinte (ex: Abertura às <strong>16:00</strong> e Fechamento às <strong>02:00</strong>). O sistema reconhecerá que o turno começa neste dia da semana e termina na madrugada do dia seguinte!
						</AlertMessage>
					</main>

					<div className="flex justify-between flex-row-reverse p-1 mt-3">
						<BtnSubmit text="Salvar" isSubmitting={isSubmitting} />
						<BtnBack onClick={() => handleCloseModalRegister()} isSubmitting={isSubmitting} />
					</div>
				</form>
			)}
		</>
	);
};

export default Form;
